import './banner.less';

const options = {
    bannerWidth: null,
    bannerHeight: null,
    elem: '.mu8-banner',
    bannerScale: 4,
};

/**
 * 初始化
 * @param {Object} newOptions 
 */
function init(newOptions) {
    if (newOptions) {
        Object.assign(options, newOptions);
    }
    options.bannerWidth = $(options.elem).eq(0).width(); // 获取容器宽度
    options.bannerHeight = options.bannerWidth / options.bannerScale // 根据比例计算出高度
    Object.assign(options, newOptions);
    options.bannerScale = options.bannerWidth / options.bannerHeight; // 重新计算比例
}

/**
 * 重设banner大小
 */
function resetBannerSize() {
    let bannerScale;
    const bannerEl = $(options.elem).eq(0);
    if (options.bannerScale) {
        bannerScale = options.bannerWidth / options.bannerHeight;
        bannerEl.height(bannerEl.width() / bannerScale); // 将banner的高度按banner图片的比例调整高度
    } else {
        bannerEl.height(options.bannerHeight); // 根据banner初始高度计算比例
        bannerEl.css({ height: options.bannerHeight, overflow: 'hidden' });
    }
}

/**
 * 渲染内容
 * @param {Object} newOptions 
 */
function render(newOptions) {
    init(newOptions);

    layui.use(['carousel'], function () {
        const carousel = layui.carousel;

        // 当窗体大小发生改变
        $(window).on('resize', () => {
            resetBannerSize();
        });

        // banner图
        carousel.render({
            elem: options.elem,
            width: '100%', //设置容器宽度
            // height: 'auto',
            arrow: 'hover', //始终显示箭头
            indicator: 'none', // 指示器位置
            // autoplay: false, // 自动播放
            interval: 3000, // 自动切换的时间间隔，单位：ms（毫秒），不能低于 800
        });

        resetBannerSize();
    });
}

export default {
    init,
    render,
}